/** SVG-иконки способов передвижения (штриховая линия дизайна Terra;
 *  вместо эмодзи — фидбек владельца 27.07). */
const S = (body: string): string =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`

export const TRAVEL_ICONS: Readonly<Record<'foot' | 'vehicle' | 'truck', string>> = {
  // Идущий человек (lucide footprints-упрощение: фигура шага)
  foot: S(
    '<circle cx="13" cy="4.5" r="1.7"/><path d="M13 7.5 9.5 12l2 3.5V21"/><path d="M9.5 12 7 14.5 5 21"/><path d="M13 7.5l3 2.5 3 1"/>',
  ),
  // Легковой автомобиль (та же линия, что глиф категории auto)
  vehicle: S(
    '<path d="M5 17h14"/><path d="M6 17v2M18 17v2"/><path d="M4 13l1.6-4.4A2 2 0 0 1 7.5 7h9a2 2 0 0 1 1.9 1.6L20 13v4H4z"/><circle cx="8" cy="14.5" r="1"/><circle cx="16" cy="14.5" r="1"/>',
  ),
  // Грузовик (кабина + кузов)
  truck: S(
    '<path d="M2 6h13v11H2z"/><path d="M15 10h4l3 3v4h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
  ),
}
